import React from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaUser,
  FaClock,
  FaChevronLeft,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailBlog5 = () => {
  const blogPost = {
    id: 5,
    title: "Fiscalité des hydrocarbures au Bénin : guide complet pour distributeurs et gérants de Stations-Service",
    excerpt: "",
    content: `
      <div class="introduction-box p-4 mb-4" style="background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border-radius: 12px; border-left: 5px solid #dc3545;">
        <p class="lead mb-0">Le secteur de la distribution des hydrocarbures au Bénin est stratégique, mais aussi fortement réglementé, notamment sur le plan fiscal. Les règles applicables aux distributeurs agréés et aux gérants de stations-service (détaillants) présentent des particularités qu'il est indispensable de maîtriser pour assurer sa conformité et optimiser sa gestion.</p>
      </div>
      
      <p>En tant qu'expert-comptable, nous vous proposons un éclairage précis sur vos obligations fiscales, illustré d'exemples concrets et fondé sur les dispositions du <strong>Code Général des Impôts (CGI)</strong> et les récentes clarifications de la Direction Générale des Impôts.</p>
      
      <div class="key-highlight-box p-4 mb-4" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 12px; border-left: 5px solid #ffc107;">
        <h4 style="color: #856404; margin-bottom: 15px;">⚡ Point Crucial à Retenir</h4>
        <p class="mb-0">La <strong>définition de votre base imposable</strong> (marge VS chiffre d'affaires total) est la clé de voûte de votre conformité fiscale. Une erreur à ce niveau peut entraîner des redressements importants.</p>
      </div>
      
      <h2 class="section-title" style="color: #dc3545; border-bottom: 3px solid #dc3545; padding-bottom: 10px; margin-top: 3rem;">1. RÉGIME FISCAL DU DISTRIBUTEUR AGRÉÉ</h2>
      
      <p>Les distributeurs agréés, qui importent et vendent les produits pétroliers en gros, sont soumis à un régime fiscal qui adapte les règles de droit commun à la structure de prix réglementée du secteur.</p>
      
      <h3 style="color: #198754; margin-top: 2rem;">📊 Impôt sur les Sociétés (IS)</h3>
      
      <div class="info-box p-4 mb-4" style="background-color: #e8f5e8; border-left: 4px solid #28a745; border-radius: 8px;">
        <p>Conformément à l'<strong>article 46 du CGI</strong>, l'impôt est calculé au taux de <strong>30%</strong> sur le bénéfice imposable.</p>
        
        <div class="mt-3 p-3" style="background-color: rgba(255, 255, 255, 0.7); border-radius: 8px;">
          <h5 style="color: #155724;">⚠️ Particularité : Calcul de l'Impôt Minimum</h5>
          <p class="mb-2">Défini à l'<strong>article 47 du CGI</strong>, la base de cet impôt n'est PAS le chiffre d'affaires total, mais :</p>
          <ul class="mb-0">
            <li>La <strong>marge "pétrolier distributeur"</strong> réalisée sur la vente des produits réglementés</li>
            <li>Augmentée du CA issu de la vente des <strong>autres biens et services</strong></li>
            <li>Plus <strong>0,6 FCFA par litre</strong> vendu dans les stations propres (si exploitation directe)</li>
          </ul>
        </div>
      </div>
      
      <h3 style="color: #0c5460; margin-top: 2.5rem;">💼 ÉTUDE DE CAS : Distributeur Agréé</h3>
      
      <div class="case-study-box p-4 mb-4" style="background: linear-gradient(135deg, #e8f4fd 0%, #d1ecf1 100%); border-radius: 15px; border: 2px solid #17a2b8; box-shadow: 0 6px 20px rgba(23, 162, 184, 0.15);">
        <h5 style="color: #0c5460; margin-bottom: 20px;">🏢 Société Pétrolière X</h5>
        
        <div class="case-data p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
          <h6 style="color: #0c5460;">📋 Données de l'exercice</h6>
          <table class="w-100 mt-3">
            <tbody>
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding: 8px 0;">Volume d'essence vendu</td>
                <td class="text-end" style="padding: 8px 0;"><strong>7 200 000 litres</strong></td>
              </tr>
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding: 8px 0;">Marge distributeur</td>
                <td class="text-end" style="padding: 8px 0;"><strong>45 FCFA/litre</strong></td>
              </tr>
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding: 8px 0;">Produits accessoires</td>
                <td class="text-end" style="padding: 8px 0;"><strong>50 000 000 FCFA</strong></td>
              </tr>
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding: 8px 0;">Produits financiers</td>
                <td class="text-end" style="padding: 8px 0;"><strong>15 000 000 FCFA</strong></td>
              </tr>
              <tr style="border-bottom: 2px solid #17a2b8;">
                <td style="padding: 8px 0;">Ventes dans stations propres</td>
                <td class="text-end" style="padding: 8px 0;"><strong>1 800 000 litres</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="calculation-section p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
          <h6 style="color: #0c5460;"> Calcul du Résultat Imposable</h6>
          <ul class="mb-2">
            <li>Produits totaux : <strong>4 961 000 000 FCFA</strong></li>
            <li>Charges totales : <strong>4 836 000 000 FCFA</strong></li>
          </ul>
          <div class="result-box p-2 mt-2" style="background-color: rgba(40, 167, 69, 0.1); border-radius: 6px; text-align: center;">
            <strong style="color: #28a745; font-size: 1.1rem;">Bénéfice imposable = 125 000 000 FCFA</strong>
          </div>
        </div>
        
        <div class="calculation-section p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
          <h6 style="color: #0c5460;"> Calcul de l'IS au taux normal</h6>
          <div class="formula-box p-3" style="background-color: rgba(23, 162, 184, 0.1); border-radius: 8px; font-family: monospace; text-align: center; font-size: 1.1rem;">
            IS = 125 000 000 × 30% = <strong style="color: #17a2b8;">37 500 000 FCFA</strong>
          </div>
        </div>
        
        <div class="calculation-section p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
          <h6 style="color: #0c5460;"> Calcul de l'IS Minimum Spécifique</h6>
          <p class="mb-2">Formule : <code>(Marge distributeur × 1%) + (Autres produits × 1%) + (Volume vente directe × 0,6)</code></p>
          <div class="calculation-steps mb-2">
            <p class="mb-1">• Marge totale : 7 200 000 L × 45 F = 324 000 000 F</p>
            <p class="mb-1">• Base minimum : (324 000 000 + 50 000 000 + 15 000 000) × 1% = <strong>3 890 000 F</strong></p>
            <p class="mb-1">• Ventes directes : 1 800 000 L × 0,6 F = <strong>1 080 000 F</strong></p>
          </div>
          <div class="result-box p-2 mt-2" style="background-color: rgba(220, 53, 69, 0.1); border-radius: 6px; text-align: center;">
            <strong style="color: #dc3545; font-size: 1.1rem;">IS Minimum = 4 970 000 FCFA</strong>
          </div>
        </div>
        
        <div class="conclusion-box p-3" style="background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%); border-radius: 10px; border-left: 5px solid #28a745;">
          <h6 style="color: #155724;"> Conclusion</h6>
          <p class="mb-0">L'impôt dû est le <strong>plus élevé des deux</strong>, soit <strong style="color: #28a745; font-size: 1.2rem;">37 500 000 FCFA</strong> (IS au taux normal)</p>
        </div>
      </div>
      
      <h3 style="color: #198754; margin-top: 2rem;">🧾 Taxe sur la Valeur Ajoutée (TVA)</h3>
      
      <p>Le rôle du distributeur en matière de TVA est double :</p>
      
      <div class="dual-role-container row mb-4">
        <div class="col-md-6 mb-3">
          <div class="role-card p-4 h-100" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%); border-radius: 12px; border-left: 5px solid #2196f3;">
            <h5 style="color: #0d47a1;"> 1. Collecteur Direct</h5>
            <p class="mb-0">Pour les ventes au détail effectuées dans ses <strong>propres stations-service</strong>, il collecte et reverse l'intégralité de la TVA due, conformément à l'<strong>article 223 du CGI</strong>.</p>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="role-card p-4 h-100" style="background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%); border-radius: 12px; border-left: 5px solid #9c27b0;">
            <h5 style="color: #4a148c;"> 2. Rétenteur à la Source</h5>
            <p class="mb-0">Lors des ventes aux autres détaillants (franchisés, locataires-gérants), le distributeur a l'obligation de <strong>retenir à la source</strong> et de reverser à l'État la TVA correspondant à la marge du détaillant (mécanisme encadré par l'<strong>article 263 du CGI</strong>).</p>
          </div>
        </div>
      </div>
      
      <h2 class="section-title" style="color: #dc3545; border-bottom: 3px solid #dc3545; padding-bottom: 10px; margin-top: 3rem;">2. RÉGIME FISCAL DU DÉTAILLANT (Gérant de Station-Service)</h2>
      
      <p>Pour les exploitants de stations-service, la compréhension de leur régime fiscal est <strong>absolument cruciale</strong>.</p>
      
      <div class="critical-point-box p-4 mb-4" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 15px; border: 3px solid #ffc107; box-shadow: 0 6px 20px rgba(255, 193, 7, 0.2);">
        <h4 style="color: #856404; margin-bottom: 15px;">🔑 LE POINT CLÉ : Définition de votre Chiffre d'Affaires</h4>
        <p style="font-size: 1.05rem; margin-bottom: 15px;">C'est la notion la plus importante à retenir :</p>
        
        <div class="alert-box p-3 mb-3" style="background-color: rgba(220, 53, 69, 0.1); border-left: 4px solid #dc3545; border-radius: 8px;">
          <p class="mb-2"><strong style="color: #dc3545;">❌ CE QUI N'EST PAS LE CA :</strong></p>
          <p class="mb-0">Le montant total des ventes de carburant à la pompe</p>
        </div>
        
        <div class="alert-box p-3" style="background-color: rgba(40, 167, 69, 0.1); border-left: 4px solid #28a745; border-radius: 8px;">
          <p class="mb-2"><strong style="color: #28a745;">✅ CE QUI CONSTITUE LE CA :</strong></p>
          <ul class="mb-0">
            <li><strong>Les commissions perçues</strong> (marge "pétrolier détaillant") sur la vente des hydrocarbures</li>
            <li><strong>Le montant des autres ventes et services</strong> (boutique, lavage auto, lubrifiants, etc.)</li>
          </ul>
        </div>
      </div>
      
      <h3 style="color: #198754; margin-top: 2rem;">📊 Impôt sur le Bénéfice (IS ou IBA)</h3>
      
      <div class="info-box p-4 mb-4" style="background-color: #e8f5e8; border-left: 4px solid #28a745; border-radius: 8px;">
        <p>L'impôt est calculé au taux de droit commun (<strong>30%</strong> pour l'IS ou l'IBA selon les <strong>articles 46 et 63 du CGI</strong>) sur le bénéfice réalisé.</p>
        
        <div class="mt-3 p-3" style="background-color: rgba(255, 255, 255, 0.7); border-radius: 8px;">
          <h5 style="color: #155724;">⚠️ Particularité : Impôt Minimum Spécifique</h5>
          <ul class="mb-0">
            <li><strong>0,6 FCFA par litre</strong> de produits pétroliers vendus (articles 47 et 64 du CGI)</li>
            <li>+ Impôt minimum classique sur le CA des activités complémentaires</li>
          </ul>
        </div>
      </div>
      
      <h3 style="color: #0c5460; margin-top: 2.5rem;">💼 ÉTUDE DE CAS : Gérant de Station-Service</h3>
      
      <div class="case-study-box p-4 mb-4" style="background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c8 100%); border-radius: 15px; border: 2px solid #28a745; box-shadow: 0 6px 20px rgba(40, 167, 69, 0.15);">
        <h5 style="color: #155724; margin-bottom: 20px;">⛽ Station-Service Y</h5>
        
        <div class="case-data p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
          <h6 style="color: #155724;">📋 Données de l'exercice</h6>
          <table class="w-100 mt-3">
            <tbody>
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding: 8px 0;">Volume d'essence vendu</td>
                <td class="text-end" style="padding: 8px 0;"><strong>1 800 000 litres</strong></td>
              </tr>
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding: 8px 0;">Commission générée</td>
                <td class="text-end" style="padding: 8px 0;"><strong>36 000 000 FCFA</strong></td>
              </tr>
              <tr style="border-bottom: 2px solid #28a745;">
                <td style="padding: 8px 0;">CA activités annexes (supérette, garage)</td>
                <td class="text-end" style="padding: 8px 0;"><strong>50 000 000 FCFA</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="calculation-section p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
          <h6 style="color: #155724;"> Calcul du Résultat Imposable</h6>
          <p class="mb-2"><strong>Produits (basés sur le VRAI chiffre d'affaires) :</strong></p>
          <ul class="mb-2">
            <li>Commission : 36 000 000 FCFA</li>
            <li>Ventes annexes : 50 000 000 FCFA</li>
            <li><strong>Total produits : 86 000 000 FCFA</strong></li>
          </ul>
          
          <p class="mb-2"><strong>Charges :</strong></p>
          <ul class="mb-2">
            <li>Achats supérette : 45 000 000 FCFA</li>
            <li>Autres charges : 30 000 000 FCFA</li>
            <li><strong>Total charges : 75 000 000 FCFA</strong></li>
          </ul>
          
          <div class="result-box p-2 mt-2" style="background-color: rgba(40, 167, 69, 0.1); border-radius: 6px; text-align: center;">
            <strong style="color: #28a745; font-size: 1.1rem;">Bénéfice imposable = 11 000 000 FCFA</strong>
          </div>
        </div>
        
        <div class="calculation-section p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
          <h6 style="color: #155724;">💰 Calcul de l'IS au taux normal</h6>
          <div class="formula-box p-3" style="background-color: rgba(40, 167, 69, 0.1); border-radius: 8px; font-family: monospace; text-align: center; font-size: 1.1rem;">
            IS = 11 000 000 × 30% = <strong style="color: #28a745;">3 300 000 FCFA</strong>
          </div>
        </div>
        
        <div class="calculation-section p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
          <h6 style="color: #155724;"> Calcul de l'IS Minimum Spécifique</h6>
          <p class="mb-2">Formule : <code>(Volume vendu × 0,6) + (CA autres activités × 1%)</code></p>
          <div class="calculation-steps mb-2">
            <p class="mb-1">• Volume : 1 800 000 L × 0,6 F = <strong>1 080 000 F</strong></p>
            <p class="mb-1">• Autres activités : 50 000 000 F × 1% = <strong>500 000 F</strong></p>
          </div>
          <div class="result-box p-2 mt-2" style="background-color: rgba(220, 53, 69, 0.1); border-radius: 6px; text-align: center;">
            <strong style="color: #dc3545; font-size: 1.1rem;">IS Minimum = 1 580 000 FCFA</strong>
          </div>
        </div>
        
        <div class="conclusion-box p-3" style="background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%); border-radius: 10px; border-left: 5px solid #28a745;">
          <h6 style="color: #155724;"> Conclusion</h6>
          <p class="mb-0">L'impôt dû est le <strong>plus élevé des deux</strong>, soit <strong style="color: #28a745; font-size: 1.2rem;">3 300 000 FCFA</strong> (IS au taux normal)</p>
        </div>
      </div>
      
      <h3 style="color: #198754; margin-top: 2rem;">🧾 Taxe sur la Valeur Ajoutée (TVA)</h3>
      
      <div class="tva-details row mb-4">
        <div class="col-md-6 mb-3">
          <div class="tva-card p-4 h-100" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 12px; border-left: 5px solid #ffc107;">
            <h5 style="color: #856404;"> Sur les hydrocarbures</h5>
            <p class="mb-2">Vous <strong>n'avez pas de TVA à collecter</strong>, car c'est le distributeur qui la retient à la source.</p>
            <p class="mb-0"><strong>➡️ Votre commission est donc à déclarer en "opérations exonérées"</strong></p>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="tva-card p-4 h-100" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%); border-radius: 12px; border-left: 5px solid #2196f3;">
            <h5 style="color: #0d47a1;"> Sur les autres activités</h5>
            <p class="mb-0">Vous devez <strong>collecter et déclarer normalement la TVA</strong> sur les ventes de votre supérette et toute autre activité taxable.</p>
          </div>
        </div>
      </div>
      
      <h2 class="section-title" style="color: #dc3545; border-bottom: 3px solid #dc3545; padding-bottom: 10px; margin-top: 3rem;">3. POINTS D'ATTENTION SPÉCIFIQUES AU SECTEUR</h2>
      
      <div class="attention-points mb-4">
        <div class="attention-item p-4 mb-3" style="background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border-radius: 12px; border-left: 5px solid #6c757d;">
          <h5 style="color: #495057;">📄 Facturation Normalisée</h5>
          <p class="mb-0">Conformément à l'<strong>article 481 du CGI</strong>, toute vente doit faire l'objet d'une facture normalisée. Dans une station en location-gérance, celle-ci doit porter le nom du <strong>gérant exploitant</strong>.</p>
        </div>
        
        <div class="attention-item p-4 mb-3" style="background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c8 100%); border-radius: 12px; border-left: 5px solid #28a745;">
          <h5 style="color: #155724;">🎫 Tickets-Valeurs et Cartes Prépayées</h5>
          <p class="mb-0">Selon l'<strong>article 236 du CGI</strong>, la TVA est exigible dès le paiement d'avances ou d'acomptes. La TVA est donc <strong>due dès la vente de ces tickets</strong> par le distributeur.</p>
        </div>
        
        <div class="attention-item p-4 mb-3" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 12px; border-left: 5px solid #ffc107;">
          <h5 style="color: #856404;"> Remises et Réductions</h5>
          <p class="mb-0">Les remises accordées entre professionnels <strong>n'ont aucun impact</strong> sur le montant de la TVA à reverser, car celle-ci est calculée sur un tarif fixe.</p>
        </div>
      </div>
      
      <div class="conclusion-section p-4 mb-4" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%); border-radius: 15px; border: 2px solid #2196f3; box-shadow: 0 6px 20px rgba(33, 150, 243, 0.15);">
        <h3 style="color: #0d47a1; margin-bottom: 20px;"> CONCLUSION : La Conformité, Carburant de votre Sérénité</h3>
        
        <p>Le régime fiscal de la distribution d'hydrocarbures au Bénin est un parfait exemple de <strong>fiscalité sectorielle adaptée</strong>. La définition de votre base imposable (marge VS chiffre d'affaires total) est la <strong>clé de voûte de votre conformité</strong>.</p>
        
        <div class="cta-box p-4 mt-4" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 12px; text-align: center;">
          <h5 style="color: #0d47a1; margin-bottom: 15px;">🤝 Besoin d'accompagnement ?</h5>
          <p class="mb-3">Pour sécuriser vos déclarations, optimiser votre gestion et vous assurer une parfaite tranquillité d'esprit, contactez l'équipe de <strong>CINEF-EXPERTISE COMPTABLE</strong>.</p>
          <p class="mb-0" style="font-style: italic; color: #6c757d;">Nous avons l'expertise sectorielle pour vous guider.</p>
        </div>
      </div>
      
      <div class="resources-section p-4 mb-4" style="background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%); border-radius: 12px; border-left: 5px solid #9c27b0;">
        <h4 style="color: #4a148c; margin-bottom: 15px;">📚 Pour aller plus loin</h4>
        <ul class="resources-list mb-0">
          <li><strong>Site de la Direction Générale des Impôts du Bénin :</strong> <a href="https://www.impots.bj/" target="_blank" rel="noopener">www.impots.bj</a></li>
          <li><strong>Site de l'Ordre des Experts-comptables :</strong> <a href="https://oeccabenin.bj/" target="_blank" rel="noopener">oeccabenin.bj</a></li>
          <li><strong>Code Général des Impôts :</strong> Consultable sur le site de la DGI</li>
        </ul>
      </div>
      
      <div class="hashtags-section p-3 text-center" style="background-color: #f8f9fa; border-radius: 8px;">
        <p class="mb-0" style="color: #6c757d; font-size: 0.9rem;">
          <strong>#Fiscalité #StationService #ExpertComptable #PME #Bénin #Hydrocarbures #CINEF #OECCA #Impôts #ConseilFiscal #DroitFiscal #Entrepreneurs #Comptabilité</strong>
        </p>
      </div>
    `,
    
    categories: ["Fiscalité", "Secteur Pétrolier", "Conformité"],
    tags: [
      "Fiscalité",
      "Hydrocarbures",
      "Station-Service",
      "Distributeur",
      "CGI",
      "Impôts",
      "TVA",
      "Bénin",
    ],
    date: "10 Octobre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable spécialisé en Fiscalité Sectorielle",
    readTime: "12 min",
    featured: true,
  };

  return (
    <>
      <Header />

      <div className="blog-content py-5">
        <div className="container">
          {/* Fil d'Ariane */}
          <nav className="breadcrumb-container mb-4">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none">
                  Accueil
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/actualites/blog" className="text-decoration-none">
                  Blog
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {blogPost.title}
              </li>
            </ol>
          </nav>

          <div className="row">
            <div className="col-lg-8">
              {/* Catégorie et Titre */}
              <div className="blog-header mb-4">
                <div className="categories-badges mb-2">
                  {blogPost.categories.map((category, index) => (
                    <span key={index} className="category-badge me-2">
                      {category}
                    </span>
                  ))}
                </div>
                <h1 className="blog-title">{blogPost.title}</h1>

                {/* Métadonnées de l'article */}
                <div className="blog-meta d-flex align-items-center mt-3">
                  <div className="meta-item d-flex align-items-center">
                    <FaCalendarAlt className="meta-icon" />
                    <span>{blogPost.date}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaUser className="meta-icon" />
                    <span>{blogPost.author}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaClock className="meta-icon" />
                    <span>{blogPost.readTime} de lecture</span>
                  </div>
                </div>
              </div>

              {/* Image principale */}
             

              {/* Extrait de l'article */}
              <div className="blog-excerpt mb-4">
                <p className="lead">{blogPost.excerpt}</p>
              </div>

              {/* Contenu principal */}
              <div
                className="blog-body mb-5"
                dangerouslySetInnerHTML={{ __html: blogPost.content }}
              />

              {/* Tags */}
              <div className="blog-tags mb-4">
                {blogPost.tags.map((tag, index) => (
                  <Link key={index} to="#" className="blog-tag">
                    #{tag}
                  </Link>
                ))}
              </div>

              {/* Partage sur les réseaux sociaux */}
              <div className="blog-share mb-5">
                <h5 className="share-title">Partager cet article</h5>
                <div className="social-buttons">
                  <a href="#" className="social-button linkedin">
                    <FaLinkedin />
                  </a>
                  <a href="#" className="social-button twitter">
                    <FaTwitter />
                  </a>
                  <a href="#" className="social-button facebook">
                    <FaFacebook />
                  </a>
                </div>
              </div>

              {/* Bouton Retour */}
              <div className="blog-actions mb-5">
                <Link to="/actualites/blog" className="btn btn-back">
                  <FaChevronLeft className="me-2" /> Retour au blog
                </Link>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-lg-4">
              {/* À propos de l'auteur */}
              <div className="sidebar-widget author-widget">
                <h4 className="widget-title">À propos de l'auteur</h4>
                <div className="author-profile">
                  <div className="author-image">
                    <img
                      src="/assets/images/image5.png"
                      alt={blogPost.author}
                      className="img-fluid rounded-circle"
                    />
                  </div>
                  <div className="author-info">
                    <h5 className="author-name">{blogPost.author}</h5>
                    <p className="author-title">{blogPost.authorTitle}</p>
                    <p className="author-bio">
                      Expert-comptable diplômé avec plus de 15 ans d'expérience dans l'accompagnement des entreprises du secteur pétrolier et de la distribution. Spécialiste reconnu de la fiscalité sectorielle au Bénin et formateur auprès de l'OECCA.
                    </p>
                  </div>
                </div>
              </div>

              {/* Widget Newsletter */}
              <div className="sidebar-widget newsletter-widget">
                <h4 className="widget-title">Newsletter</h4>
                <p className="newsletter-desc">
                  Recevez nos conseils fiscaux et les dernières actualités du secteur pétrolier
                </p>
                <form className="newsletter-form">
                  <div className="form-group mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Votre adresse email"
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">
                    S'abonner
                  </button>
                </form>
              </div>

              {/* Widget Liens utiles */}
              <div className="sidebar-widget categories-widget">
                <h4 className="widget-title">Ressources Fiscales</h4>
                <ul className="categories-list">
                  <li>
                    <a
                      href="https://www.impots.bj"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Direction Générale des Impôts <span>→</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://oeccabenin.bj/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ordre des Experts-Comptables <span>→</span>
                    </a>
                  </li>
                  <li>
                    <Link to="/services/audit-conseil">
                      Conseil Fiscal Personnalisé <span>→</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/actualites/blog">
                      Autres articles fiscaux <span>→</span>
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Widget Contact Expert */}
              <div className="sidebar-widget" style={{ background: "linear-gradient(135deg, #dc3545 0%, #198754 100%)", color: "white", borderRadius: "12px" }}>
                <h4 className="widget-title" style={{ color: "white", borderBottom: "2px solid rgba(255,255,255,0.3)" }}>
                  Besoin d'aide ?
                </h4>
                <p style={{ fontSize: "14px", marginBottom: "15px" }}>
                  Nos experts sont à votre disposition pour vous accompagner dans votre conformité fiscale.
                </p>
                <Link 
                  to="/contact" 
                  className="btn w-100"
                  style={{ 
                    backgroundColor: "white", 
                    color: "#dc3545",
                    fontWeight: "600",
                    borderRadius: "25px",
                    padding: "12px"
                  }}
                >
                  Contactez-nous
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <style jsx>{`
        /* Styles généraux */
        .blog-content {
          background-color: #f8f9fa;
        }

        /* Fil d'Ariane */
        .breadcrumb {
          background-color: transparent;
          padding: 0;
          margin-bottom: 0;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          color: #6c757d;
        }

        .breadcrumb-item a {
          color: #6c757d;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .breadcrumb-item a:hover {
          color: #dc3545;
        }

        .breadcrumb-item.active {
          color: #212529;
          font-weight: 500;
        }

        /* En-tête du blog */
        .blog-header {
          margin-bottom: 2rem;
        }

        .blog-title {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1rem;
          line-height: 1.2;
          color: #212529;
        }

        .category-badge {
          display: inline-block;
          background: linear-gradient(to right, #dc3545, #198754);
          color: white;
          padding: 6px 15px;
          border-radius: 30px;
          font-size: 14px;
          font-weight: 600;
        }

        .blog-meta {
          color: #6c757d;
          font-size: 14px;
          gap: 20px;
          flex-wrap: wrap;
        }

        .meta-item {
          gap: 5px;
        }

        .meta-icon {
          font-size: 14px;
          margin-right: 5px;
          color: #dc3545;
        }

        /* Image principale */
        .blog-featured-image img {
          border-radius: 10px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        /* Extrait */
        // .blog-excerpt .lead {
        //   font-size: 1.25rem;
        //   font-weight: 300;
        //   line-height: 1.6;
        //   color: #495057;
        //   border-left: 4px solid #dc3545;
        //   padding-left: 20px;
        //   background-color: #fff;
        //   padding: 20px;
        //   border-radius: 8px;
        // }

        /* Contenu du blog */
        .blog-body {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #212529;
        }

        .blog-body h2 {
          margin-top: 2.5rem;
          margin-bottom: 1.5rem;
          font-weight: 700;
          color: #212529;
        }

        .blog-body h3 {
          margin-top: 2rem;
          margin-bottom: 1rem;
          font-weight: 700;
          color: #212529;
        }

        .blog-body h4 {
          margin-top: 1.5rem;
          margin-bottom: 0.8rem;
          font-weight: 600;
          color: #343a40;
        }

        .blog-body h5 {
          margin-top: 1.2rem;
          margin-bottom: 0.6rem;
          font-weight: 600;
        }

        .blog-body p {
          margin-bottom: 1.5rem;
        }

        .blog-body ul,
        .blog-body ol {
          margin-bottom: 1.5rem;
          padding-left: 1.5rem;
        }

        .blog-body li {
          margin-bottom: 0.8rem;
        }

        .blog-body a {
          color: #dc3545;
          text-decoration: none;
          font-weight: 500;
        }

        .blog-body a:hover {
          text-decoration: underline;
        }

        .blog-body code {
          background-color: #f8f9fa;
          color: #e83e8c;
          padding: 2px 6px;
          border-radius: 4px;
          font-size: 0.9em;
          font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
        }

        .blog-body strong {
          font-weight: 600;
          color: #212529;
        }

        .blog-body table {
          width: 100%;
          border-collapse: collapse;
          margin: 1.5rem 0;
        }

        .blog-body table td {
          padding: 8px 0;
        }

        /* Tags */
        .blog-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 2rem;
          padding-top: 2rem;
          border-top: 1px solid #dee2e6;
        }

        .blog-tag {
          display: inline-block;
          background-color: #e9ecef;
          color: #495057;
          padding: 5px 12px;
          border-radius: 20px;
          text-decoration: none;
          font-size: 13px;
          transition: all 0.3s ease;
        }

        .blog-tag:hover {
          background-color: #dc3545;
          color: white;
          transform: translateY(-2px);
        }

        /* Partage social */
        .blog-share {
          margin-top: 2rem;
          padding-top: 1.5rem;
          border-top: 1px solid #dee2e6;
        }

        .share-title {
          font-size: 1rem;
          margin-bottom: 1rem;
          color: #495057;
          font-weight: 600;
        }

        .social-buttons {
          display: flex;
          gap: 15px;
        }

        .social-button {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          font-size: 18px;
        }

        .social-button:hover {
          transform: translateY(-3px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        .linkedin {
          background-color: #0077b5;
        }

        .twitter {
          background-color: #1da1f2;
        }

        .facebook {
          background-color: #4267b2;
        }

        /* Bouton retour */
        .btn-back {
          display: inline-flex;
          align-items: center;
          background-color: white;
          color: #495057;
          padding: 12px 24px;
          border-radius: 30px;
          text-decoration: none;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          font-weight: 500;
        }

        .btn-back:hover {
          background-color: #dc3545;
          color: white;
          transform: translateX(-5px);
          box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
        }

        /* Sidebar Widgets */
        .sidebar-widget {
          background-color: white;
          border-radius: 12px;
          padding: 25px;
          margin-bottom: 30px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
        }

        .widget-title {
          font-size: 1.25rem;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 2px solid #f0f0f0;
          position: relative;
          font-weight: 700;
        }

        .widget-title:after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 60px;
          height: 2px;
          background: linear-gradient(to right, #dc3545, #198754);
        }

        /* Widget Auteur */
        .author-profile {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        .author-image {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          overflow: hidden;
          margin-bottom: 15px;
          border: 3px solid #dc3545;
        }

        .author-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .author-name {
          font-size: 18px;
          margin-bottom: 5px;
          font-weight: 700;
        }

        .author-title {
          font-size: 14px;
          color: #dc3545;
          margin-bottom: 10px;
          font-weight: 500;
        }

        .author-bio {
          font-size: 14px;
          color: #6c757d;
          margin-bottom: 0;
          line-height: 1.6;
        }

        /* Widget Newsletter */
        .newsletter-desc {
          margin-bottom: 15px;
          color: #6c757d;
          font-size: 14px;
        }

        .btn-primary {
          background: linear-gradient(45deg, #dc3545, #198754);
          border: none;
          border-radius: 30px;
          padding: 12px 25px;
          font-weight: 600;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);
        }

        .btn-primary::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.2),
            transparent
          );
          transition: left 0.5s ease;
        }

        .btn-primary:hover::before {
          left: 100%;
        }

        .newsletter-form .form-control {
          border-radius: 25px;
          border: 2px solid #e9ecef;
          padding: 12px 20px;
          transition: all 0.3s ease;
        }

        .newsletter-form .form-control:focus {
          border-color: #dc3545;
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
        }

        /* Widget Liens utiles */
        .categories-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .categories-list li {
          margin-bottom: 12px;
        }

        .categories-list a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 15px;
          background-color: #f8f9fa;
          color: #495057;
          text-decoration: none;
          border-radius: 8px;
          transition: all 0.3s ease;
          font-weight: 500;
        }

        .categories-list a:hover {
          background-color: #dc3545;
          color: white;
          transform: translateX(5px);
        }

        .categories-list a span {
          font-weight: bold;
          transition: transform 0.3s ease;
        }

        .categories-list a:hover span {
          transform: translateX(5px);
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .blog-title {
            font-size: 2rem;
          }

          .blog-meta {
            flex-direction: column;
            gap: 10px;
            align-items: flex-start;
          }

          .meta-item {
            width: 100%;
          }

          .blog-body {
            font-size: 1rem;
          }

          .social-buttons {
            justify-content: center;
          }

          .author-profile {
            flex-direction: row;
            text-align: left;
            gap: 15px;
          }

          .author-image {
            width: 80px;
            height: 80px;
            margin-bottom: 0;
            flex-shrink: 0;
          }

          .author-info {
            flex: 1;
          }

          .categories-list a {
            padding: 10px 12px;
          }
        }
      `}</style>
    </>
  );
};

export default DetailBlog5;